export const ItemTypes = {
  Default: 'default',
  MoreButton: 'more-button',
};

export const ItemsAlignment = {
  Left: 'left',
  Center: 'center',
  Right: 'right',
};

export const ItemsDisplayMode = {
  Icons: 'icons',
  Titles: 'titles',
  IconsTitles: 'icons_titles',
};
